/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import EditableBtn from 'components/lib/EditableBtn';
import { useContext } from 'react';
import { unlockInteraction } from 'services/unlockInteraction';
import { FiveStarRatingContext } from './FiveStarRating_v2';
import { interactionContext } from './interactionContext';
import { addScormResponseAction } from 'actions/addScormResponseAction';
import { useDispatch } from 'react-redux';

const myFeedbackApp = ({
  key,
  rating,
  message,
  identity,
  reference,
  onComplete = ({}) => {},
}) => {
  const myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-Type', 'application/json');

  //
  const raw = JSON.stringify({
    key,
    response: {
      content: message,
      rating,
      identity,
      reference,
    },
  });

  const requestOptions: any = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  //
  let endPoint;

  try {
    endPoint =
      window['collectResponseEndpoint'] ||
      window.top!['collectResponseEndpoint'] ||
      'https://collect.chameleoncreator.com/api/v1/responses/create';
  } catch (err) {
    console.log('ERROR GETTING REFERENCE TO COLLECT ENDPOINT :', err);
    //
    endPoint =
      window['collectResponseEndpoint'] ||
      'https://collect.chameleoncreator.com/api/v1/responses/create';
  }

  if (!(window as any).hosted) {
    fetch(endPoint, requestOptions)
      .then(response => {
        return response.text();
      })
      .then(result => {
        onComplete(result);
      })
      .catch(error => console.log('error', error));
  }
};

const SubmitBtn = props => {
  const context = useContext(interactionContext)!;
  const {
    hasLearnerIdentity,
    learnerIdentity,
    rating,
    message,
    alertLearnerIdentity,
    onSubmit,
  } = useContext(FiveStarRatingContext)!;

  const dispatch = useDispatch();

  const {
    useMyFeedbackApp,
    // ratingEndpoint,
    emailRequired,
    reference = '',
    collectionKey = '',
    submissionEmailDestination,
    subject,
    includeMessageText = true,
    isTextEntry,
  } = context.props;

  let ratingEndpoint = context.props?.ratingEndpoint;
  // ratingEndpoint will be undefined for modules before we
  // made the update to include hosting
  //
  if (!ratingEndpoint) {
    if (useMyFeedbackApp) {
      ratingEndpoint = 'collect';
    } else {
      ratingEndpoint = 'email';
    }
  }

  // console.log('SUBMIT TO :', { ratingEndpoint }, ratingEndpoint === 'collect');

  const submitted = unlockInteraction(context.id, 1);

  let enabled = includeMessageText === false || message !== '';

  // if (useMyFeedbackApp && emailRequired) {
  if (ratingEndpoint === 'collect' && emailRequired) {
    if (includeMessageText) {
      enabled = hasLearnerIdentity && message !== '';
    } else {
      enabled = hasLearnerIdentity;
    }
  }

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        width: 100%;
        margin: 20px 0 0 0;
        ${!window.dev() &&
          `
            opacity: ${enabled ? 1 : 0.25};
            pointer-events: ${enabled ? 'auto' : 'none'};
            transition: opacity 0.5s;
        `}
      `}
    >
      <EditableBtn
        onClick={() => {
          if (ratingEndpoint === 'scorm') {
            if (!isTextEntry) {
              const questionElement = document.querySelector(
                `#i${context.id} .rating-text`
              ) as HTMLElement;

              let question = '';

              if (questionElement) {
                question = questionElement.innerText;
              }

              const response = `Rating: ${rating + 1}, Message: ${message}`;

              const action = {
                id: context.id,
                type: 'likert',
                question,
                reportable: 'likert' as 'likert',
                response,
                correct: String(rating + 1),
                result: 1,
              };

              console.log('Rating: ', action);

              dispatch(addScormResponseAction(action as any));

              onSubmit(true);
              submitted(1);
              return;
            }

            onSubmit();
            submitted(1);
            return;
          }
          //
          //

          if (ratingEndpoint === 'collect') {
            myFeedbackApp({
              key: collectionKey,
              rating: rating === null || isTextEntry ? undefined : rating + 1,
              message,
              identity: learnerIdentity,
              reference,
              onComplete(result) {
                console.log(`${result} submitted successfully to collect !!!`);
                //
                onSubmit();
              },
            });

            submitted(1);
            return;
          }

          const parsedMessage = `Rating: ${
            rating !== null ? rating + 1 : 'not rated'
          }\r\n\r\n${message}`;

          location.href = `mailto:${submissionEmailDestination}?${subject &&
            `subject=${encodeURIComponent(subject)}&`}body=${encodeURIComponent(
            parsedMessage
          )}`;

          onSubmit();
          submitted(1);
        }}
        enabled={enabled}
        {...props}
      />
    </div>
  );
};

export default SubmitBtn;
